import React from 'react';
import { builderSetSamplingRate } from '../../../../redux/slices/oldBuilder';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import {
  builderDefaultOptionsSelector,
  builderSamplingRateSelector,
} from '../../../../redux/selectors/builder';
import { assertCondition } from '../../../../utils/types';
import SamplePercentageMenu from './SamplePercentageMenu';

const BuilderSamplePercentage = () => {
  const dispatch = useAppDispatch();

  const defaultOptions = useAppSelector(builderDefaultOptionsSelector);
  const currentValue = useAppSelector(builderSamplingRateSelector);

  assertCondition(defaultOptions && 'samplingRate' in defaultOptions);

  const handleChange = (newValue: number) => {
    dispatch(builderSetSamplingRate({ newValue }));
  };

  return (
    <SamplePercentageMenu
      value={currentValue || defaultOptions.samplingRate}
      onChange={handleChange}
    />
  );
};

export default BuilderSamplePercentage;
